import { render, staticRenderFns } from "./TradeTransferList.vue?vue&type=template&id=c8b6073a&scoped=true&"
import script from "./TradeTransferList.vue?vue&type=script&lang=js&"
export * from "./TradeTransferList.vue?vue&type=script&lang=js&"
import style0 from "./TradeTransferList.vue?vue&type=style&index=0&id=c8b6073a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b6073a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8b6073a')) {
      api.createRecord('c8b6073a', component.options)
    } else {
      api.reload('c8b6073a', component.options)
    }
    module.hot.accept("./TradeTransferList.vue?vue&type=template&id=c8b6073a&scoped=true&", function () {
      api.rerender('c8b6073a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/History/TradeTransferList.vue"
export default component.exports